import React from 'react';
import { usePermission } from './PermissionsContext';

interface CanProps {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const Can: React.FC<CanProps> = ({ permission, children, fallback = null }) => {
  const allowed = usePermission(permission);
  if (!allowed) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
};

export default Can;
